import React from 'react';
import { Form, Button, Icon, Message, Dropdown } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';


//dropdown EMPRESAS

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.tipoProducto} dato2={props.elemento.ficha?props.elemento.ficha:''} 
    dato3={props.elemento.descrUnidad?props.elemento.descrUnidad:''} 
    dato4={props.elemento.precio?props.elemento.precio:0} 
    dato5={props.elemento.porcIVA?props.elemento.porcIVA:0} 
    dato6={props.elemento.precioDolar?props.elemento.precioDolar:0} 
    dato7={props.elemento.porcImpto?props.elemento.porcImpto:0}
    dato8={props.elemento.ficha2?props.elemento.ficha2:''}
    dato9={props.elemento.vigenteHasta?props.elemento.vigenteHasta:''}
    dato10={props.elemento.estado?props.elemento.estado:''}
    dato11={props.elemento.numProducto} dato12={props.elemento.descrCorta?props.elemento.descrCorta:''}
    value={props.elemento.descrProducto}>{props.elemento.descrProducto}</option>
  )
};

const ListaPro = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui fluid search selection dropdown" name="descrProducto" id="miLista44" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};


  class AddItemTras2 extends React.Component{
    state={argsAdd: {}, listaItem: this.props.allProducto.allProducto}

  render(){
   const { argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)
    args._id = this.props.idLista._id
    args.numCoti = this.props.idLista.numCoti
    let listPro=[]
    let listaItem=this.state.listaItem
    let buscItem = ''
    if(args.descrProductoB){
      buscItem = args.descrProductoB
    }
    listPro = listaItem.filter(elemento => elemento.tipoProducto==='Producto' && elemento.estado==='Activo')
    if(buscItem){
      listPro = listPro.filter(elemento => elemento.descrProducto.toLowerCase().indexOf(buscItem.toLowerCase()) > -1)
    }
console.log(args)
    return(
  
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Item de traslado nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui three column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '90%'}}>                
                <Form.Field>
                  <div className="ui input fluid">
                    <input id='descrProductoB' autoComplete="off" name="descrProductoB" type="text" placeholder="Buscar producto" style={this.props.styles.dropdown} onChange={this.props.handleChange}/>
                  </div>
                </Form.Field>    
              </div>
            </div>
            <div className="row container">
              <div className="column" style={{width: '90%'}}>  
                <label style={this.props.styles.label}>Producto</label>
                <Form.Field>
                  <ListaPro list={listPro} handleLista={this.props.handleLista} />
                </Form.Field>    
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Cantidad</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="cantidadCoti" id="cantidadCoti" placeholder='Cantidad' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
    
  )
  }
}

export default compose(
  graphql(queries.query.allProducto, {name:'allProducto'}),


  )(AddItemTras2)